/**
 * RPDM Wave 2-UI · Phase 2 · Disabled Delivery Sub-Page.
 *
 * Placeholder body for the five delivery sub-tabs that are OUT OF
 * SCOPE for Phase 2 (`overview`, `dependencies`, `progress`, `effort`,
 * `analytics`). Rendered when a caller navigates directly to one of
 * these routes via URL (the sub-nav entries themselves are disabled
 * spans, not links, so this page is only reachable via manual URL
 * entry or bookmarked link).
 */
import { FailClosedPlaceholder } from "../../../../components/rpdm/FailClosedPlaceholder";

const LABELS = {
    overview: "Overview",
    dependencies: "Dependencies",
    progress: "Progress",
    effort: "Effort",
    analytics: "Analytics",
};

export default function DeliveryDisabledPage({ sectionKey }) {
    const label = LABELS[sectionKey] || "This section";
    return (
        <FailClosedPlaceholder
            title={`${label} is not enabled in Phase 2`}
            message="This delivery capability lands in a later phase. For now, only the read-only hierarchy is available."
            testId={`rpdm-delivery-disabled-${sectionKey}`}
        />
    );
}
